import { useEffect, useState } from 'react'
import { fetchTimecodedVtt } from './transcriptionApi'

/**
 * Fetches the raw WebVTT for a timecoded media item and exposes it as a
 * same-origin blob URL suitable for a native <track src>. Returns undefined
 * when the media item isn't timecoded or has no transcription. Revokes the
 * object URL on change/unmount to avoid leaks.
 */
export const useTimecodedTrackUrl = (
	mediaItemId: number | undefined,
	transcriptionFormat: string | undefined,
	language: string,
): string | undefined => {
	const [url, setUrl] = useState<string | undefined>(undefined)

	useEffect(() => {
		let active = true
		let created: string | undefined

		setUrl(undefined) // drop stale URL immediately on any change
		if (transcriptionFormat !== 'timecoded' || !mediaItemId) {
			return
		}

		fetchTimecodedVtt(mediaItemId, language).then(vtt => {
			if (!active || !vtt) return
			created = URL.createObjectURL(new Blob([vtt], { type: 'text/vtt' }))
			setUrl(created)
		})

		return () => {
			active = false
			if (created) URL.revokeObjectURL(created)
		}
	}, [mediaItemId, transcriptionFormat, language])

	return url
}
